<template>
    <div>
        <div class="p-grid">
            <app-menu-bar title="Form Edit Role" back_url="/roles"/>
            <Card class="p-fluid">
                <template #content>
                    <div class="field grid">
                        <label for="name" class="col-12 mb-2 md:col-2 md:mb-0">Kode </label>
                        <div class="col-12 md:col-10">
                            <InputText id="name" type="text" :class="{'p-invalid' : errors.kode}" v-model="form.kode" />
                            <small v-if="errors.kode" id="name-help" class="p-error">Kode Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="name" class="col-12 mb-2 md:col-2 md:mb-0">Nama </label>
                        <div class="col-12 md:col-10">
                            <InputText id="name" type="text" :class="{'p-invalid' : errors.name}" v-model="form.name" />
                            <small v-if="errors.name" id="name-help" class="p-error">Nama Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <div class="col-6">
                            <PermissionTreeTable v-model="form.permissions" title="Role Permissions"> </PermissionTreeTable>
                        </div>
                        <div class="col-6">
                            <MenuTreeTable v-model="form.menus" title="Role Menus"> </MenuTreeTable>
                        </div>
                    </div>
                    
                    
                </template>  
                <template #footer>
                    <div class="field grid">
                        <div class="col-offset-2">
                            <Button icon="pi pi-send" label="Simpan" class="p-button p-button-primary ml-2" @click="submitForm()"/>
                        </div>
                    </div>
                </template>
            </Card>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Menubar from "primevue/menubar";
import AppMenuBar from "../../Components/AppMenuBar.vue";
import {FilterMatchMode} from "primevue/api";
import { useForm } from "@inertiajs/inertia-vue3"
import Column from "primevue/column";
import Button from "primevue/button";
import Divider from "primevue/divider";
import Card from "primevue/card";
import DeleteDialog from "../../Components/DeleteDialog";
import { Inertia } from '@inertiajs/inertia'
import TreeTable from 'primevue/treetable';
import PermissionService from '../../Services/PermissionService';
import Checkbox from 'primevue/checkbox';
import PermissionTreeTable from '../../Components/PermissionTreeTable';
import MenuTreeTable from '../../Components/MenuTreeTable';

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        AppMenuBar,
        DataTable,
        Column, 
        Button,
        DeleteDialog,
        InputText,
        Password,
        Card,
        Divider,
        TreeTable,
        Checkbox,
        PermissionTreeTable,
        MenuTreeTable,
    },
    data() {
        return { 
            nodes : null, 
            // selected_permission : [],
            expandedKeys : {}
        }
    },
    permissionService : null,
    props : {
        errors : Array,
        form : Array,
    },
    methods : {
        submitForm(){
            // alert(this.form)
            // this.form.permissions = this.selected_permission;
            Inertia.put(`/roles/${this.form.id}`, this.form);
        },
        console_log(param){
            console.log(param);
        },
    }
}
</script>
